import React, { useEffect, useState } from 'react';

import { CallendarBlackIcon, EyeIcon, NotificationBlackIcon, CalendarGreyIcon, BlackCardIcon, CalendarRedIcon, LocationGreenIcon, WhiteCardIcon, CategoryBlackIcon, ListBlackIcon, MenuBlackIcon, NewBlackIcon } from '../../../assets/icons';
import PaymantInfoView from './PaymantInfoView';
import { LocalDashboardInfoDTO } from '../../../models/local/local.response';
import { useNotification } from '../../toster-notification/NotificationContext';
import Loader from '../../shared/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import { localService } from '../../../services/localService';
import { handleErrorNotification } from '../../../utils/errorNotificatioMessage';
import { ToLocalDateString } from '../../../utils/dateFormater';
import { notificationTypeToString } from '../../../models/base/NotificationType';

const DashboardPage: React.FC = () => {

    const [PaymentInfoOpen, setPaymentInfoOpen] = useState(false);
    const [dashboardData, setDashboardData] = useState<LocalDashboardInfoDTO | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const localId = useParams().localId;

    const { notify } = useNotification();

    const navigate = useNavigate();


    useEffect(() => {
        fetchDashboardData();
    }, [localId]);


    const fetchDashboardData = async () => {
        if (!localId) {
            notify("error", "Lokal ID nije pronađen.");
            return;
        }

        setLoading(true);
        try {
            const response = await localService.getLocalDashboardInfo(localId);

            if (response.success && response.data) {
                setDashboardData(response.data);
            } else {
                notify("error", response.message || "Greška prilikom učitavanja podataka.");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja podataka.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    function DaysUntilPlanEnd(planEndAt: Date): number {
        const currentDate = new Date();
        const endDate = new Date(planEndAt);
        const timeDifference = endDate.getTime() - currentDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
        return daysDifference;
    }

    if (!dashboardData) {
        return null;
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {PaymentInfoOpen &&
                <PaymantInfoView
                    onClose={() => setPaymentInfoOpen(false)
                    }
                />}

            <section className="dashboard-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Dashboard</h2>
                                <div className="description-text">
                                    Pregled vašeg digitlnog menija<br />
                                </div>
                            </div>
                        </div>

                        <div className={`admin-settings-box-div dashboard-plan-time-left ${DaysUntilPlanEnd(dashboardData.planEndAt) <= 7 ? 'red' : ''}`}>
                            {DaysUntilPlanEnd(dashboardData.planEndAt) <= 7 ? (
                                <div className="div-block-25">
                                    <img src={CalendarRedIcon} loading="lazy" alt="" className="icon-size-24" />
                                    <div className="list-header-info">
                                        <div className="list-header-title">Članarina ističe uskoro</div>
                                        <div className="list-header-description">
                                            Vaša članarina ističe u narednih {DaysUntilPlanEnd(dashboardData.planEndAt)} dana. Preporučujemo da je produžite na vreme.<br />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="div-block-25">
                                    <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-24" />
                                    <div className="list-header-info">
                                        <div className="list-header-title">Članarina je važeća</div>
                                        <div className="list-header-description">
                                            Vaša članarina ističe u narednih {DaysUntilPlanEnd(dashboardData.planEndAt)} dana. Preporučujemo da je produžite na vreme.<br />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="info-settings-div dashboard-plan-left">
                                <div className="dashboard-plan-time-left-div">
                                    <div className="dashboard-plan-time-left-header-div">
                                        <div className="description-text">Preostalo vreme</div>
                                        <div className={`dashboard-plan-time-left-text ${DaysUntilPlanEnd(dashboardData.planEndAt) <= 7 ? 'red' : ''}`}>{DaysUntilPlanEnd(dashboardData.planEndAt)} dana</div>
                                    </div>
                                    <div className="dashboard-plan-time-left-scale-div">
                                        <div className="dashboard-plan-time-left-scale-absolute-div" style={{ width: `${((30 - DaysUntilPlanEnd(dashboardData.planEndAt)) / 30) * 100}%` }}></div>
                                    </div>
                                </div>
                                <div className="dashboard-plan-time-left-info-bloack">
                                    <div className="dashboard-plan-time-left-info-date-block">
                                        <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-20" />
                                        <div className="dashboard-plan-time-left-info-date-div">
                                            <div className="description-text">Datum isteka</div>
                                            <div>
                                                {new Date(dashboardData.planEndAt).toLocaleDateString()}<br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dashboard-plan-time-left-info-date-block">
                                        <img src={LocationGreenIcon} loading="lazy" alt="" className="icon-size-20" />
                                        <div className="dashboard-plan-time-left-info-date-div">
                                            <div className="description-text">Lokacija</div>
                                            <div className="text-block-29">
                                                {dashboardData.name}, {dashboardData.address}<br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dashboard-plan-buttons-div">
                                    <div className="button-secondary" onClick={() => setPaymentInfoOpen(true)}>
                                        <img src={BlackCardIcon} loading="lazy" alt="" className="icon-size-16" />
                                        <div>
                                            <strong>Produži članarinu</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="admin-settings-box-div plan-info">
                            <div className="list-header-info">
                                <div className="div-block-26">
                                    <img src={BlackCardIcon} loading="lazy" alt="" className="icon-size-20" />
                                    <div className="list-header-title">Članarina</div>
                                </div>
                                <div className="list-header-description">
                                    Upravljajte svojim planom i plaćanjima<br />
                                </div>
                            </div>
                            <div className="info-settings-div dasboard-plan-info">
                                <div className="dashboard-plan-info-row">
                                    <div className="description-text">Status:</div>
                                    <div className="small-box-div grey-bg">
                                        {dashboardData.planIsActive ? (
                                            <>
                                                <div className="_12px-green-dot-div"></div>
                                                <div>Aktivna</div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="_12px-green-dot-div" style={{ "backgroundColor": "red" }}></div>
                                                <div>Nije aktivna</div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div id="w-node-_6fdffd73-c434-1582-e78e-0f915ecf10d6-1cee91cf" className="button-primary dashboard-plan-info" onClick={() => setPaymentInfoOpen(true)}>
                                    <img src={WhiteCardIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>
                                        <strong>Plati članarinu</strong>
                                    </div>
                                </div>
                                <div className="dashboard-plan-info-row">
                                    <div className="description-text">Ističe:</div>
                                    <div>
                                        {ToLocalDateString(dashboardData.planEndAt.toString())}<br />
                                    </div>
                                </div>
                                <div className="dashboard-plan-info-row">
                                    <div className="description-text">Plan:</div>
                                    <div>
                                        {dashboardData.planName}<br />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-data-info-list-div">
                            <div className="dashboard-data-info-div">
                                <div className="dashboard-data-info-header-div">
                                    <div>Kategorije</div>
                                    <img loading="lazy" src={CategoryBlackIcon} alt="" className="icon-size-20" />
                                </div>
                                <div className="dashboard-data-info-footer">
                                    <div className="dashboard-data-info-number">
                                        {dashboardData.activeCategoriesCount} Aktivnih <span className="description-text text-span">(od {dashboardData.categorysCount})</span>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div dashboard-data-info-div">
                                <div className="dashboard-data-info-header-div">
                                    <div>Podkategorije</div>
                                    <img loading="lazy" src={ListBlackIcon} alt="" className="icon-size-20" />
                                </div>
                                <div className="dashboard-data-info-footer">
                                    <div className="dashboard-data-info-number">
                                        {dashboardData.activeSubcategoriesCount} Aktivnih <span className="description-text text-span">(od {dashboardData.subcategoryCount})</span>
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-data-info-div">
                                <div className="dashboard-data-info-header-div">
                                    <div>Stavke menija</div>
                                    <img loading="lazy" src={MenuBlackIcon} alt="" className="icon-size-20" />
                                </div>
                                <div className="dashboard-data-info-footer">
                                    <div className="dashboard-data-info-number">
                                        {dashboardData.activeProductsCount} Aktivnih <span className="description-text text-span">(od {dashboardData.productsCount})</span>
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-data-info-div">
                                <div className="dashboard-data-info-header-div">
                                    <div>Nove stavke</div>
                                    <img loading="lazy" src={NewBlackIcon} alt="" className="icon-size-20" />
                                </div>
                                <div className="dashboard-data-info-footer">
                                    <div className="dashboard-data-info-number">
                                        {dashboardData.activeNewProductsCount} Aktivnih <span className="description-text text-span">(od {dashboardData.newProductsCount})</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-footer">
                            <div className="admin-settings-box-div dashboard-quick-access-div">
                                <div className="dashboard-quick-access-header">
                                    <img loading="lazy" src={EyeIcon} alt="" className="dashboard-quick-access-photo" />
                                    <div>Brzi pristup</div>
                                </div>
                                <div className="dashboard-quick-access-list-div">
                                    <div
                                        className="dashboard-quick-access-entity-div"
                                        onClick={() => window.open(`/client-menu/${localId}/online`, '_blank', 'noopener,noreferrer')}
                                    >
                                        <div className="dashboard-quick-access-entity-name">Pogledaj meni kao gost</div>
                                    </div>
                                    <div className="dashboard-quick-access-entity-div" onClick={() => navigate(`/settings/${localId}/menu-items`)}>
                                        <div className="dashboard-quick-access-entity-name">Dodaj novu stavku</div>
                                    </div>
                                    <div className="dashboard-quick-access-entity-div" onClick={() => navigate(`/settings/${localId}/qr-code`)}>
                                        <div className="dashboard-quick-access-entity-name">Preuzmi QR kod</div>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div dashboard-notification-div">
                                <div className="dashboard-notification-header-div">
                                    <img loading="lazy" src={NotificationBlackIcon} alt="" className="icon-size-20" />
                                    <div>Aktivne notifikacije</div>
                                </div>
                                <div className="dashboard-notification-entity-list">
                                    {dashboardData.notifications.length === 0 && (
                                        <div className="description-text">Nema aktivnih notifikacija.</div>
                                    )}

                                    {dashboardData.notifications.map((notification, index) => (
                                        <div className="dashboard-notification-entity-div" key={index}>
                                            <div className="small-box-div grey-bg">
                                                <div>{notificationTypeToString(notification.notificationType)}</div>
                                            </div>
                                            <div className="dashboard-notification-entity-info">
                                                <div className="dashboard-notification-entity-description">{notification.title}</div>
                                                <div className="description-text">{notification.message}</div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DashboardPage;